export default [
	{
		path: '/risk/add/:id?',
		name: 'riskAdd',
		component: () => import('@/views/risk/add.vue'),
		meta:{title:'卒中复发风险评估'}
	},
    {
		path: '/risk/detail/:id?',
		name: 'riskDetail',
		component: () => import('@/views/risk/detail.vue'),
		meta:{title:'卒中复发风险评估'}
	}
]
